import React, { useCallback } from 'react';
import MenuItem from '@mui/material/MenuItem';

import { Membership_Type } from '@occc/graphql';

import { memberEmployeeStatusLabels } from './constants';
import { MembershipTypeIcon } from './MembershipTypeIcon';

type MemberTypeMenuItemProps = {
  selected: boolean;
  value: Membership_Type;
  onSelect: (value: Membership_Type) => void;
};

export const MemberTypeMenuItem = React.forwardRef<HTMLLIElement, MemberTypeMenuItemProps>(
  ({ onSelect, value, selected }, ref) => {
    const onClick = useCallback(() => {
      onSelect(value);
    }, [value, onSelect]);

    return (
      <MenuItem onClick={onClick} selected={selected} ref={ref}>
        <MembershipTypeIcon membershipType={value} isSelected={selected} />
        {memberEmployeeStatusLabels[value]}
      </MenuItem>
    );
  },
);
